<template>
  <div class="license-list">
    <div class="frame oripalette" @click="gotoSite('https://oripalette.jp/')">
      <div class="logo_img">
        <img src="/img/license/oripalette.png" alt="オリパレット" />
      </div>
      <div class="license_text">
        <div class="license_title">株式会社TUUUBE</div>
        <div class="license_link">
          <span>サイトを見る ➜</span>
        </div>
      </div>
    </div>
    <div class="frame gachaon" @click="gotoSite('https://gachaon.com/')">
      <div class="logo_img">
        <img src="/img/license/gachaon.PNG" alt="GachaOn" />
      </div>
      <div class="license_text">
        <div class="license_title">GachaOn</div>
        <div class="license_link">
          <span>サイトを見る ➜</span>
        </div>
      </div>
    </div>
    <div class="frame hachikuzi" @click="gotoSite('https://gacha.bee-honpo.com/')">
      <div class="logo_img">
        <img src="/img/license/hachikuzi.JPG" alt="はちくじ" />
      </div>
      <div class="license_text">
        <div class="license_title">株式会社山王商会</div>
        <div class="license_link">
          <span>サイトを見る ➜</span>
        </div>
      </div>
    </div>
    <div class="frame magi" @click="gotoSite('https://magi.camp/')">
      <div class="logo_img">
        <img src="/img/license/magi.png" alt="magi" />
      </div>
      <div class="license_text">
        <div class="license_title">Jiraffe Inc.</div>
        <div class="license_link">
          <span>サイトを見る ➜</span>
        </div>
      </div>
    </div>
    <div class="frame sodainc" @click="gotoSite('https://snkrdunk.com/oripa?slide=right')">
      <div class="logo_img">
        <img src="/img/license/sodainc.png" alt="sodainc" />
      </div>
      <div class="license_text">
        <div class="license_title">SODA Inc.</div>
        <div class="license_link">
          <span>サイトを見る ➜</span>
        </div>
      </div>
    </div>
    <div class="frame hatchi" @click="gotoSite('')">
      <div class="logo_img">
        <!-- <img src="/img/license/hachikuzi.JPG" alt="はちくじ" /> -->
        <span>準備中</span>
      </div>
      <div class="license_text">
        <div class="license_title">株式会社はっち</div>
        <!-- <div class="license_link">
          <span>サイトを見る ➜</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicenseList',
  methods: {
    gotoSite(url) {
      if (url === '') {
        return;
      }
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.license-list{
  display: flex;
  flex-wrap: wrap;
  .frame {
    cursor: pointer;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 15px 30px;
    margin: 0 10px 10px;
    width: 285px;
    min-width: 285px;
    .logo_img {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 85px;
      }
    }
    .license_text {
      margin-top: 10px;
      .license_title {
        font-weight: bold;
        font-size: 18px;
        color: black;
      }
      .license_link {
        font-size: 12px;
        color: #2f2f2f;
        margin-top: 5px;
      }
    }
  }
  .frame.oripalette {
    .logo_img {
      height: 85px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .frame.hatchi {
    .logo_img {
      height: 85px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .frame.sodainc {
    .logo_img {
      height: 85px;
      img {
        width: 80%;
        height: auto;
        @media screen and (max-width: $tabletWidth) {
          width: 60%;
        }
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .license-list{
    .frame {
      width: 100%;
    }
    .frame.oripalette {
      .logo_img {
        img {
          width: 70%;
        }
      }
    }
  }
}
</style>
